import { useEffect, useRef } from "react";

import { acquireSocket, releaseSocket } from "../socket/socket";

function readAccessToken() {
   if (typeof document === "undefined") return "";
   const match = document.cookie.match(/(?:^|;\s*)access_token=([^;]+)/);
   return match ? decodeURIComponent(match[1]) : "";
}

export default function useChatSocket(enabled, onMessage) {
   const handlerRef = useRef(onMessage);
   handlerRef.current = onMessage;

   useEffect(() => {
      if (!enabled) return undefined;

      const token = readAccessToken();
      if (!token) return undefined;

      const socket = acquireSocket(token);
      if (!socket) return undefined;

      const register = () => {
         try {
            socket.emit("register");
         } catch {}
      };

      const handleChatMessage = (payload) => {
         try {
            handlerRef.current?.(payload);
         } catch {}
      };

      socket.on("connect", register);
      socket.on("chat:message", handleChatMessage);
      if (socket.connected) register();

      return () => {
         socket.off("connect", register);
         socket.off("chat:message", handleChatMessage);
         releaseSocket();
      };
   }, [enabled]);
}
